
import { Component, Vue, Prop } from "vue-property-decorator";
import TeacherItem from "./TeacherItem.vue";
@Component({
  components: {
    TeacherItem
  }
})
export default class Teacher extends Vue {
  @Prop({ required: true }) private list!: any;

  handleAll() {
    this.$router.push(`/teacher`);
  }
  handleDetail(index: any) {
    this.$router.push(`/teacher?index=${index + 1}`);
  }
}
